export interface BureauFavorite {
  fieldName: string;
  sortOrder: string;
}

export interface BureauFavorites {
  favorites: BureauFavorite[];
}

export const defaultBureauFavorites = {
  favorites: []
};